export const get_payment_method_details_query = `
  query Get_payment_method($option_id: Int!, $option_type: String!) {
    payment_method_details(option_id: $option_id, option_type: $option_type) {
      key
      title
      type
      option_id
      option_type
      additional_fields {
        label
        name
        default_value
        sort_order
        type
        required
        is_account_identifier
        is_mutable
        data
      }
      templates {
        token
        label
        data
      }
      payment_rails {
        key
        title
      }
      allow_new_card
      is_spread_amount
      payout_condition
      is_obt_supported
      redirection_type
      window_size_width
      window_size_height
      skip_customer_details
      card_tokenization_options {
        token_provider
        enabled
        card_funding_sources
        card_types
        currency_list
      }
    }
  }
`;
